<script lang="ts">
	import EnergyV2Dashboard from './v2/EnergyV2Dashboard.svelte';
	import { ENERGY_DASHBOARD_ID } from './v2/energy-v2-types';

	export let id: string | number | undefined;
</script>

<EnergyV2Dashboard dashboardId={id ?? ENERGY_DASHBOARD_ID} />
